import { ApiInterface, EmptyObject } from '@stetamalo/cloud-platform/catalog/api';
import { ApiConfig } from 'services/support/utils/types/api-config';
export type Interface = ApiInterface<{
  response: { success: true };
  pathParams: { lashitasId: string };
  body: EmptyObject;
  claims: { tenantId: string };
  queryParams: EmptyObject;
}>;

export const config: ApiConfig<Interface> = {
  name: 'api-delete-lashitas',
  method: 'DELETE',
  basePath: 'lashitas',
  path: '/{lashitasId}',
  tablePermission: 'readWrite',
  scope: 'ADMIN',
};
